import { useEffect, useState } from 'react';
import { ApiError, request } from '../api/client';
import { Screen } from '../ui';
import NotFound from './NotFound';

/**
 * Admin-only. A non-admin sees the same not-found page as any unknown route rather than
 * an error that confirms the route exists.
 */
export default function AdminMetrics() {
  const [metrics, setMetrics] = useState<Record<string, unknown> | null>(null);
  const [forbidden, setForbidden] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    void (async () => {
      try {
        const data = await request<Record<string, unknown>>('/metrics');
        if (live) setMetrics(data);
      } catch (err) {
        if (!live) return;
        // A non-admin is shown the ordinary not-found page rather than an error that
        // confirms the route exists.
        if (err instanceof ApiError && (err.kind === 'unauthorized' || err.kind === 'forbidden')) {
          setForbidden(true);
          return;
        }
        setError(err instanceof Error ? err.message : 'Could not reach the server.');
      }
    })();
    return () => {
      live = false;
    };
  }, []);

  if (forbidden) return <NotFound />;

  return (
    <Screen title="Metrics">
      {error && <p role="alert" className="type-caption field-error-text">{error}</p>}
      {metrics && <pre className="submission-row type-caption">{JSON.stringify(metrics, null, 2)}</pre>}
    </Screen>
  );
}
